var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autralis-status-buttons',{attrs:{"classNameConfig":_vm.classNameConfig,"states":_vm.states,"saving":_vm.saving,"error":_vm.error},on:{"on-change":_vm.changeStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }